import React from "react";
import MedicoAssistenteSteps from "./steps/MedicoAssistenteSteps";
import { MedicoAssistenteStoreProvider } from '../../../context/MedicoAssistenteContext';

export default function MedicoAssistente() {

    return (
        <MedicoAssistenteStoreProvider>
            <MedicoAssistenteSteps />
        </MedicoAssistenteStoreProvider>
    )

}